export default function PolicyFilter({
  policyIds,
  selectedPolicyId,
  setSelectedPolicyId,
  currentCategory,
  onchange,
}) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      <div className="my-4 md:my-0 md:flex-strech md:items-center pt-3">
        {policyIds?.length > 0 && currentCategory !== "COMMISSIONS" && (
          <div className="mb-8 md:mb-8">
            <label id="ID_messageDateLabel" htmlFor="ID_messageDate">
              Policy Number
            </label>
            <select
              id="ID_messageDate"
              aria-labelledby="ID_messageDateLabel"
              className="bg-white"
              value={selectedPolicyId}
              onChange={(e) => {
                setSelectedPolicyId(e.target.value);
                onchange(e.target.value);
              }}
            >
              <option value="">- Select Policy -</option>
              {policyIds.map((policy, idx) => {
                return (
                  <option value={policy} key={`main category - ${idx}`}>
                    {policy}
                  </option>
                );
              })}
            </select>
          </div>
        )}
      </div>
    </div>
  );
}
